import { APITypes } from '../primary-record-types';

export type AddressToStringArgs = {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
};

export default function addressToString({ address1, address2, city, state, zipCode }: AddressToStringArgs): string {
    let addressString = address1?.trim();

    if (address2) {
        addressString += (addressString ? '\n' : '') + address2;
    }

    // @ts-expect-error TS2322
    if (!city && !state && !zipCode) return addressString;

    addressString += (addressString ? '\n' : '') + `${city ? `${city}, ` : ''} ${state || ''} ${zipCode || ''}`;

    // @ts-expect-error TS2322
    return addressString;
}

export const oneUpEndpointAddressToString = (endpoint: APITypes.ehrIntegrationsService.OneUpHealthEndpoint) => {
    const addressArgs: AddressToStringArgs = {
        address1: (endpoint.locations?.[0]?.address?.line || []).join(' '),
        city: endpoint.locations?.[0]?.address?.city,
        state: endpoint.locations?.[0]?.address?.state,
    };

    return addressToString(addressArgs);
};
